import moment from 'moment';
const INITIAL_STATE = {
  orders : [],
  orderFilter : {
    fromDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
    toDate: moment().add(7, 'd').format('YYYY-MM-DD'),
    typeValue: 'startLoad',
  }
};
export default function customerOrders(state = INITIAL_STATE, { type, payload }) {

  // console.log('type >>>>', type);
  // console.log('payload >>>>', payload);
  switch (type) {
    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'orders') {
        const url_string = new URL(payload.response.config.url && payload.response.config.url)
        const fromDate = url_string.searchParams.get("fromDate");
        const toDate = url_string.searchParams.get("toDate");
        const typeValue = url_string.searchParams.get("loadType");
        const orders = [
          ...state.orders,
          ...payload.response.data.reverse(),
        ];

        const ordersList = [...new Map(orders.map(order => [order.logon_customer_order_number, order])).values()]

        return {
          orders: ordersList,
          orderFilter : {
            fromDate : fromDate,
            toDate : toDate,
            typeValue: typeValue, 
          }
        };
      }

      else if(payload && payload.key === 'filterOrders') {
        const url_string = new URL(payload.response.config.url && payload.response.config.url)
        const fromDate = url_string.searchParams.get("fromDate");
        const toDate = url_string.searchParams.get("toDate");
        const typeValue = url_string.searchParams.get("loadType");
        const orders = [
          ...payload.response.data.reverse(),
        ];
        const ordersList = [...new Map(orders.map(order => [order.logon_customer_order_number, order])).values()]

        return {
          orders: ordersList,
          orderFilter : {
            fromDate : fromDate,
            toDate : toDate,
            typeValue: typeValue,
          }
        };
      }


      return state;
    }

    case 'clearFilter': {
        return INITIAL_STATE
      }
    
    default:
      return state;
  }
}
